import { DELEGATION_ID_TN_STR } from '@/src/utils/constants';
import { type PaymentKeyHash } from '@lucid-evolution/lucid';
import 'reflect-metadata';
import { AssetClass, Convertible, Maybe, StakeCredentialPubKeyHash, asSmartDBEntity, type CS } from '../Commons';
import { BaseSmartDBEntity } from './index.exports';

@asSmartDBEntity()
export class DelegationEntity extends BaseSmartDBEntity {
    protected static _apiRoute: string = 'delegation';
    protected static _className: string = 'Delegation';

    protected static _plutusDataIndex = 0;
    protected static _is_NET_id_Unique = false;

    // #region fields

    _NET_id_TN_Str: string = DELEGATION_ID_TN_STR;

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;
    
    // #endregion fields

    // #region datum

    @Convertible({ isForDatum: true })
    ddVersion!: number;

    @Convertible({ isForDatum: true, type: String })
    ddDelegationPolicyID_CS!: CS;

    @Convertible({ isForDatum: true, type: String })
    ddFundPolicy_CS!: CS;

    @Convertible({ isForDatum: true, type: String })
    ddDelegatorPaymentPKH!: PaymentKeyHash;

    @Convertible({ isForDatum: true, type: Maybe<StakeCredentialPubKeyHash> })
    ddDelegatorStakePKH!: Maybe<StakeCredentialPubKeyHash>;

    @Convertible({ isForDatum: true, type: AssetClass })
    ddTokenGov_AC!: AssetClass;

    @Convertible({ isForDatum: true })
    ddStaked!: bigint;

    @Convertible({ isForDatum: true })
    ddMinADA!: bigint;


    // #endregion datum

    // #region  db

    public static defaultFieldsWhenUndefined: Record<string, boolean> = {};

    public static alwaysFieldsForSelect: Record<string, boolean> = {
        ...super.alwaysFieldsForSelect,
        ddVersion: true,
        ddDelegationPolicyID_CS: true,
        ddFundPolicy_CS: true,
        ddDelegatorPaymentPKH: true,
        ddDelegatorStakePKH: true,
        ddTokenGov_AC: true,
        ddStaked: true,
        ddMinADA: true,
    };

    // #endregion  db

    // #region class methods

    public getNET_id_CS(): string {
        return this.ddDelegationPolicyID_CS;
    }

    // #endregion class methods
}
